import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-textView",
  "use": "icon-textView-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-textView\">\n<path d=\"M3.16737 8.31641H0.564453\" stroke=\"#323232\" />\n<path d=\"M15.4419 8.31641H5.03027\" stroke=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol